import { ReactElement } from 'react';

export default function ContentHeader(props): ReactElement {
  return (
    <div
      className={`w-full min-h-32 h-full ${
        props.clearClass ? '' : 'bg-orange-50'
      }`}
    >
      <div className="h-full flex flex-col items-center justify-center p-12">
        <h1 className="text-2xl md:text-4xl font-medium">
          {props.btitle}{' '}
          <span style={{ color: '#FA8C16' }}>{props.otitle}</span>
        </h1>
        {props.stitle && (
          <h2
            className={`text-xl mt-8 text-center ${
              props.clearClass ? '' : 'max-w-sm '
            }`}
          >
            {props.stitle}
          </h2>
        )}
      </div>
    </div>
  );
}
